import React, { useEffect } from 'react';
import { TextFormat, Translate, translate } from 'react-jhipster';
import { Link } from 'react-router-dom';

import { getEntity as getScheduling } from '../../../entities/scheduling/scheduling.reducer';
// import { getEntity } from '../scheduling/scheduling.reducer';
import { CloseRounded, OpenInNewRounded } from '@mui/icons-material';
import {
  Box,
  Chip,
  Dialog,
  DialogTitle,
  IconButton,
  styled,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  ThemeProvider,
  Typography,
  useTheme,
} from '@mui/material';
import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { Status } from 'app/shared/model/enumerations/scheduling-status.model';
import { IScheduling } from 'app/shared/model/scheduling.model';

type ISchedulingDetailModalProps = {
  modalOpen: any;
  setModalOpen: any;
  props: any;
};

export const SchedulingDetailModal = React.memo(({ modalOpen, setModalOpen, props }: ISchedulingDetailModalProps) => {
  const dispatch = useAppDispatch();
  const theme = useTheme();
  const schedulingEntity = useAppSelector(state => state.scheduling.entity);
  const schedulingId = props?.match.params.schedulingId || '';

  useEffect(() => {
    if (schedulingId) {
      dispatch(getScheduling(schedulingId));
    }
  }, [dispatch, schedulingId]);

  const statusChip = ({ status }: IScheduling) => (
    <Chip
      sx={{ width: '115px' }}
      label={status ? <Translate contentKey={`fleetSenseApp.SchedulingStatus.${status}`} /> : ''}
      color={status === Status.SCHEDULED ? 'warning' : status === Status.CANCELED ? 'error' : 'success'}
    />
  );

  const headers = [
    { key: 'status', sortable: true, component: <Translate contentKey="fleetSenseApp.scheduling.status" /> },
    { key: 'startTime', sortable: true, component: <Translate contentKey="fleetSenseApp.scheduling.startTime" /> },
    { key: 'endTime', sortable: true, component: <Translate contentKey="fleetSenseApp.scheduling.endTime" /> },
    { key: 'description', sortable: false, component: <Translate contentKey="fleetSenseApp.scheduling.description" /> },
    { key: 'id', sortable: true, component: <Translate contentKey="fleetSenseApp.scheduling.id" /> },
  ];
  const headers2 = [
    { key: 'truckImplementPlate', sortable: false, component: <Translate contentKey="fleetSenseApp.scheduling.truckImplementPlate" /> },
    { key: 'truckImplementDescription', sortable: false, component: <Translate contentKey="fleetSenseApp.scheduling.truckImplementDescription" /> },
    { key: 'userFirstName', sortable: false, component: <Translate contentKey="fleetSenseApp.scheduling.user" /> },
    { key: 'schedulingType', sortable: false, component: <Translate contentKey="fleetSenseApp.scheduling.type" /> },
    { key: 'schedulingMethod', sortable: false, component: <Translate contentKey="fleetSenseApp.scheduling.method" /> },
    { key: 'createdBy', sortable: false, component: <Translate contentKey="fleetSenseApp.scheduling.createdBy" /> },
  ];
  const toggleModal = () => {
    setModalOpen(prev => !prev);
  };

  return (
    <ThemeProvider theme={theme}>
      <Dialog
        open={modalOpen}
        maxWidth="lg"
        fullWidth
        PaperProps={{ sx: { borderRadius: '15px', background: theme.palette.primary.main } }}
        sx={{
          boxShadow:
            'rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px',
        }}
      >
        <DialogTitle id="dialog-title" sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {translate('fleetSenseApp.schedulingHistory.detail.title')}
          <IconButton onClick={toggleModal}>
            <CloseRounded color="secondary" />
          </IconButton>
        </DialogTitle>
        <Box sx={{ height: '40vh' }} padding={'5px'}>
          <Table aria-label="scheduling table">
            <TableHead>
              <TableRow>
                {headers.map((header, i) => (
                  <TableCell
                    key={`entity-${i}`}
                    sx={{
                      borderBottom: 'none',
                      paddingBottom: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        color: 'text.primary',
                        fontSize: '0.875rem',
                        fontWeight: '600',
                        alignItems: 'center',
                      }}
                    >
                      {header.component}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow
                sx={{
                  whiteSpace: 'nowrap',
                  backgroundColor: 'background.paper',

                  borderTop: '4px solid',
                  borderBottom: '4px solid',
                  borderColor: 'primary.main',
                }}
              >
                <CustomHeadTableCell>{statusChip(schedulingEntity)}</CustomHeadTableCell>
                <CustomHeadTableCell>
                  {schedulingEntity?.startTime ? <TextFormat type="date" value={schedulingEntity.startTime} format={APP_DATE_FORMAT} /> : null}
                </CustomHeadTableCell>
                <CustomHeadTableCell>
                  {schedulingEntity?.endTime ? <TextFormat type="date" value={schedulingEntity.endTime} format={APP_DATE_FORMAT} /> : null}
                </CustomHeadTableCell>
                <CustomHeadTableCell>{schedulingEntity?.description}</CustomHeadTableCell>
                <CustomHeadTableCell>{props?.match.params.schedulingId}</CustomHeadTableCell>
              </TableRow>
              <TableRow>
                {headers2.map((header, i) => (
                  <TableCell
                    key={`entity-${i}`}
                    sx={{
                      borderBottom: 'none',
                      paddingBottom: 1,
                    }}
                  >
                    <Typography
                      sx={{
                        color: 'text.primary',
                        fontSize: '0.875rem',
                        fontWeight: '600',
                        alignItems: 'center',
                      }}
                    >
                      {header.component}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
              <TableRow
                sx={{
                  whiteSpace: 'nowrap',
                  backgroundColor: 'background.paper',

                  borderTop: '4px solid',
                  borderBottom: '4px solid',
                  borderColor: 'primary.main',
                }}
              >
                <CustomHeadTableCell>
                  {schedulingEntity.truckImplement?.licensePlate}
                  <IconButton color="secondary" component={Link} to={`dashboards/truck-implement/${schedulingEntity?.truckImplement?.id}`}>
                    <OpenInNewRounded fontSize="small" />
                  </IconButton>
                </CustomHeadTableCell>
                <CustomHeadTableCell>{schedulingEntity.truckImplement?.description}</CustomHeadTableCell>
                <CustomHeadTableCell>
                  {schedulingEntity?.user?.firstName} {schedulingEntity?.user?.lastName}
                  <IconButton color="secondary" component={Link} to={`admin/user-management?emailSearch=${encodeURIComponent(schedulingEntity?.user?.email)}`}>
                    <OpenInNewRounded fontSize="small" />
                  </IconButton>
                </CustomHeadTableCell>
                <CustomHeadTableCell>{translate(`fleetSenseApp.SchedulingTypes.${schedulingEntity?.type}`)}</CustomHeadTableCell>
                <CustomHeadTableCell>{translate(`fleetSenseApp.SchedulingMethod.${schedulingEntity?.method}`)}</CustomHeadTableCell>
                <CustomHeadTableCell>{schedulingEntity?.createdBy}</CustomHeadTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </Dialog>
    </ThemeProvider>
  );
});

const CustomHeadTableCell = styled(TableCell)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
}));
